import React, { Component } from 'react';
import classnames from 'classnames';

import { connect } from 'react-redux';

import { getUrl } from 'helpers/getUrl';

import IframePreviewComponent from 'components/IframePreviewComponent';
import getEnv from 'helpers/getEnv';

class PreviewPhone extends Component {
  render() {
    const { selectedPhone, account } = this.props;

    return (
      <div className="preview-phone">
        <div
          className={classnames('preview-phone__inner', {
            [selectedPhone]: !!selectedPhone,
          })}>
          <div className="phone-iframe">
            <IframePreviewComponent
              src={getUrl(getEnv('REACT_APP_BACKEND_URL'), account.short_code, {
                preview: true,
                cache: Date.now(),
              })}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateProps(state) {
  return {
    account: state.content.account,
  };
}
export default connect(mapStateProps)(PreviewPhone);



// WEBPACK FOOTER //
// ./src/components/PreviewPhone/PreviewPhone.js